<script>
    export let SERVER;
    export let product;

    let dealTypes = {
        'group_buying': 'Group buying',
    };
</script>

<div class="col-12 col-sm-12 col-md-6 col-lg-3">
    <div class="card">
        {#if product.video}
            <video controls class="card-img-top" poster="{SERVER}/storage/{product.image}">
                <source src="{SERVER}/storage/{product.video}" type="video/mp4">
                Your browser does not support the video tag.
            </video>
        {:else}
            <img src="{SERVER}/storage/{product.image}" class="card-img-top" alt="...">
        {/if}
        <div class="card-body">
            <h5 class="card-title">{product.title}</h5>
        </div>
        <div class="card-footer">
            ₱ {product.price}
        </div>
        {#each product.deals as deal}
            <div class="card-footer">
                {dealTypes[deal.type]}: ₱ {deal.price}
            </div>
        {/each}
    </div>
</div>

<style>

</style>
